import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { AppConfigService, FiltersArray } from "src/app/core";
import { SearchFilter, SearchFiltersService } from "src/app/shared";
import { GetVenueTemplatesFiltersResponse, VenueAdminResponses } from "../responses/venue-admin-responses";

@Injectable()
export class VenueAdminTemplatesPresetsFilterService extends SearchFiltersService {
  private _searchKeyword: string;
  private _source: string;

  constructor(private _appConfigService: AppConfigService, private _http: HttpClient) {
    super();
  }

  setSearchKeyword(keyword: string): void {
    this._searchKeyword = keyword;

    super.raiseFiltersChanged();
  }

  buildFiltersArray(): FiltersArray {
    const filters = super.buildFiltersArray();

    if (!!this._searchKeyword) {
      filters.push({ name: "Keywords", values: [this._searchKeyword.split(" ").join("|")] });
    }

    if (!!this._source) {
      filters.push({ name: "Source", values: [this._source] });
    }

    return filters;
  }

  getTemplatesPresetsFilters$(venueId: number): Observable<SearchFilter[]> {
    return this._http
      .get<GetVenueTemplatesFiltersResponse>(this._appConfigService.getVenueAdminTemplatesPresetsTemplateFiltersUrl(venueId))
      .pipe(
        map(response => {
          const sourceAndFilters: [string, SearchFilter[]] = VenueAdminResponses.getVenueTemplatesFiltersFromResponse(response);
          this._source = sourceAndFilters[0];

          return sourceAndFilters[1];
        }),
      );
  }
}
